module.exports = __webpack_public_path__ + "static/media/x.826a11cb.svg";